import { useEffect } from "react";

import { PreloadedQuery } from "react-relay";

import { PricingContentContextProviderRelay } from "@/components/wpl/pricing/src/pricing-content-context.tsx";
import { pricingPageRelayQuery } from "@/contentful/graphql/pricing-page";
import { TeamworkCollectionPricingPageTemplate } from "@/templates/collections/teamwork/pricing/teamwork-collection-pricing-page.template.tsx";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";
import { PricingContent } from "@/utils/pricing-queries/get-pricing-content-gql.ts";
import { UserLocale } from "@/utils/useGeoCurrency.ts";

import { AppPricingData } from "../../../../contentful/index.tsx";

export interface TeamworkCollectionPricingPageRelayProps {
    pricing?: AppPricingData;
    countryCode?: UserLocale;
    pricingContent?: PricingContent;
    queryRef: PreloadedQuery<typeof pricingPageRelayQuery>;
}

export const TeamworkCollectionPricingPageRelay = (
    props: TeamworkCollectionPricingPageRelayProps
) => {
    const { pricingContent, pricing, countryCode, queryRef } = props;

    useEffect(() => {
        checkFeatureFlagGate(featureFlags.cpapiwdPricingAll);
    }, []);

    return (
        <PricingContentContextProviderRelay
            productId="teamwork-collection"
            pricingContent={pricingContent}
            queryRef={queryRef}
        >
            <TeamworkCollectionPricingPageTemplate />
        </PricingContentContextProviderRelay>
    );
};
